export const getCardsLimit = (isLarge: boolean, isSmall: boolean) => {
  if (isLarge) return 8;
  if (isSmall) return 4;
  return 6;
};
